import { useEffect } from 'react';
import { useAuth } from 'contexts/AuthContext';

/**
 * Hook personalizado para validar token em componentes protegidos
 * Verifica automaticamente se o token expirou e redireciona para login se necessário
 */
export const useTokenValidation = () => {
  const { isTokenExpired, clearSessionAndRedirect, user } = useAuth();

  useEffect(() => {
    // Só verificar se há um usuário logado
    if (user) {
      // Aguardar um pouco para evitar verificação imediata que pode causar re-render
      const timer = setTimeout(() => {
        if (isTokenExpired()) {
          clearSessionAndRedirect(true);
          return;
        }

        // Configurar verificação periódica (a cada 5 minutos)
        const interval = setInterval(() => {
          if (isTokenExpired()) {
            clearSessionAndRedirect(true);
            clearInterval(interval);
          }
        }, 5 * 60 * 1000); // 5 minutos

        // Cleanup
        return () => clearInterval(interval);
      }, 100); // Pequeno delay para evitar verificação imediata

      return () => clearTimeout(timer);
    }
  }, [user, isTokenExpired, clearSessionAndRedirect]); // Mantém a checagem estável sem encadear re-renders

  return { isTokenExpired };
};

export default useTokenValidation;
